/** 
  All of the routes for the Cakes By Sim Admin are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Cakes By Sim Admin layouts
import ResetIllustration from "components/layouts/authentication/reset-password/illustration";

// Cakes By Sim Admin icons
import Document from "components/examples/Icons/Document";
import { LoginView } from "views/LoginView";
import { Videocam } from "@mui/icons-material";
import CustomerSupport from "components/examples/Icons/CustomerSupport";
import { CreateCourseView } from "views/courses/create/CreateCourseView";
import { CoursesView } from "views/courses/all/CoursesView";
import { CustomersView } from "views/customers/all/CustomersView";
import { EditCourseView } from "views/courses/edit/EditCourseView";
import { Navigate } from "react-router-dom";
import { EditCustomerView } from "views/customers/edit/EditCustomerView";
import NewUser from "components/layouts/pages/users/new-user";

const routes = [
  // {
  //   // type: "collapse",
  //   name: "Dashboards",
  //   key: "dashboards",
  //   icon: <Dashboard size="12px" />,
  //   collapse: [
  //     {
  //       name: "Default",
  //       key: "default",
  //       route: "/admin/dashboard",
  //       component: <Default />,
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Customers",
    key: "customers",
    icon: <CustomerSupport size="12px" />,
    collapse: [
      // this router is to breadcrumb know where it should be redirected
      {
        name: "View Customers",
        key: "all-redirect",
        route: "/admin/customers",
        component: <Navigate to="/admin/customers/all" />,
        hidden: true
      },
      {
        name: "View Customers",
        key: "all",
        route: "/admin/customers/all",
        component: <CustomersView />,
      },
      {
        name: "Edit Customers",
        key: "all",
        route: "/admin/customers/all/edit/:id",
        component: <EditCustomerView />,
        hidden: true
      }
    ],
  },
  {
    type: "collapse",
    name: "Courses",
    key: "courses",
    icon: <Videocam size="12px" />,
    collapse: [
      {
        name: "Create Course",
        key: "create",
        route: "/admin/courses/create",
        component: <CreateCourseView />,
      },
      {
        name: "View Courses",
        key: "all-redirect",
        route: "/admin/courses",
        component: <Navigate to="/admin/courses/all" />,
        hidden: true
      },
      {
        name: "View Courses",
        key: "all",
        route: "/admin/courses/all",
        component: <CoursesView />,
      },
      {
        name: "Edit Courses",
        key: "edit",
        route: "/admin/courses/all/edit/:id",
        component: <EditCourseView />,
        hidden: true
      }
    ],
  },
  {
    // type: "collapse",
    name: "Authentication",
    key: "authentication",
    icon: <Document size="12px" />,
    collapse: [
      {
        name: "Sign In",
        key: "sign-in",
        collapse: [
          {
            name: "Illustration",
            key: "illustration",
            route: "/authentication/sign-in",
            component: <LoginView />,
          },
        ],
      },
      {
        name: "Reset Password",
        key: "reset-password",
        collapse: [
          {
            name: "Illustration",
            key: "illustration",
            route: "/authentication/reset-password",
            component: <ResetIllustration />,
          },
        ],
      }
    ],
  },
];

export default routes;
